const tables = document.querySelectorAll('.rich-text table');

const wrapTable = el => {
  // Custom CKEditor tables already have their own wrap + desktop-centered layout.
  if (el.classList.contains('opella-richtext-table') || el.closest('.opella-richtext-table-wrap')) {
    return;
  }
  const wrappingElement = document.createElement('div');
  wrappingElement.setAttribute('role', 'region');
  el.replaceWith(wrappingElement);
  wrappingElement.classList.add('table-wrap');
  wrappingElement.appendChild(el);
}

tables.forEach(el => wrapTable(el));
